// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sArb","right":"styles_right__nY6B5"};